import { render, staticRenderFns } from "./paintBrush.vue?vue&type=template&id=4781b1db&scoped=true"
import script from "./paintBrush.vue?vue&type=script&lang=js"
export * from "./paintBrush.vue?vue&type=script&lang=js"
import style0 from "./paintBrush.vue?vue&type=style&index=0&id=4781b1db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781b1db",
  null
  
)

export default component.exports